import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export default function HowItWorksSection() {
  const { t } = useTranslation();

  const steps = [
    {
      number: '01',
      title: t('how_step1_title'),
      subtitle: t('how_step1_subtitle'),
      description: t('how_step1_desc'),
      icon: 'ri-upload-cloud-line',
    },
    {
      number: '02',
      title: t('how_step2_title'),
      subtitle: t('how_step2_subtitle'),
      description: t('how_step2_desc'),
      icon: 'ri-coin-line',
    },
    {
      number: '03',
      title: t('how_step3_title'),
      subtitle: t('how_step3_subtitle'),
      description: t('how_step3_desc'),
      icon: 'ri-shield-check-line',
    },
  ];

  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-br from-neutral-bg to-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl font-bold text-neutral-dark mb-4">
            {t('how_title')}
          </h2>
          <p className="text-xl text-neutral-text">
            {t('how_subtitle')}
          </p>
        </motion.div>

        <div className="relative">
          <div className="hidden lg:block absolute top-32 left-0 right-0 h-1">
            <div className="max-w-5xl mx-auto h-full bg-gradient-to-r from-primary via-primary-light to-primary-lighter opacity-20"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 relative">
            {steps.map((step, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2, duration: 0.6 }}
                className="relative"
              >
                <div className="flex flex-col items-center mb-6">
                  <div className="w-40 h-40 bg-white rounded-full shadow-xl flex items-center justify-center relative z-10 border-4 border-primary/10">
                    <div className="text-center">
                      <div className="text-5xl font-bold bg-gradient-primary bg-clip-text text-transparent mb-2">
                        {step.number}
                      </div>
                      <i className={`${step.icon} text-3xl text-primary`}></i>
                    </div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
                  <h3 className="text-2xl font-bold text-neutral-dark mb-2">
                    {step.title}
                  </h3>
                  <div className="text-primary font-semibold mb-4">
                    {step.subtitle}
                  </div>
                  <p className="text-neutral-text leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-32 -right-6 z-20">
                    <i className="ri-arrow-right-line text-4xl text-primary/30"></i>
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
